import { useCallback } from 'react'
import { useOrganizationSettingsQuery } from '@/hooks/queries/useOrganizationSettingsQuery'
import { useOrganizationSettingsStore } from '@/store/organization-settings.store'

/**
 * Hook that provides time formatting functions with effective settings baked in.
 * Combines useOrganizationSettingsQuery (for effective settings) with
 * useOrganizationSettingsStore (for formatting utilities).
 */
export function useTimeFormat() {
  const { data: settingsData } = useOrganizationSettingsQuery()
  const formatTime = useOrganizationSettingsStore(state => state.formatTime)
  const parseTime = useOrganizationSettingsStore(state => state.parseTime)
  const getTimeFormat = useOrganizationSettingsStore(
    state => state.getTimeFormat,
  )
  const effectiveSettings = settingsData?.effectiveSettings

  return {
    formatTime: useCallback(
      (hours: number) => formatTime(hours, effectiveSettings),
      [formatTime, effectiveSettings],
    ),
    parseTime: useCallback(
      (timeString: string) => parseTime(timeString, effectiveSettings),
      [parseTime, effectiveSettings],
    ),
    getTimeFormat: useCallback(
      () => getTimeFormat(effectiveSettings),
      [getTimeFormat, effectiveSettings],
    ),
  }
}
